import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [{ id: 'name', label: t('Master-data.topics.table-col-1') }];
